import CloseIcon from '@mui/icons-material/Close';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	useTheme,
} from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface TaModalProps {
	open: boolean;
	onClose: () => void;
	title?: string;
	modalTitle?: string;
	children: ReactNode;
	saveButtonTitle?: string;
	saveButtonLoading?: boolean;
	showActions?: boolean;
	save?: () => void;
	disableSaveButton?: boolean | any;
	disableCancelButton?: boolean;
}

export const TaModal = ({
	open,
	onClose,
	title,
	children,
	saveButtonLoading,
	modalTitle,
	saveButtonTitle = 'save',
	save,
	showActions = true,
	disableSaveButton,
	disableCancelButton,
}: TaModalProps) => {
	const { t } = useTranslation();
	const theme = useTheme();

	return (
		<>
			<Dialog
				open={open}
				onClose={onClose}
				fullWidth
				maxWidth="sm"
				sx={{
					'& .MuiPaper-root': {
						borderRadius: '15px',
						boxShadow: '0px 2px 6px 0px #00000040',
						width: '540px',
						[theme.breakpoints.down('sm')]: {
							width: '390px',
						},
					},
				}}
			>
				<DialogTitle
					sx={{
						display: 'flex',
						justifyContent: modalTitle || title ? 'space-between' : 'flex-end',
						alignItems: 'center',
						borderBottom: modalTitle || title ? '1px solid #E0E0E0' : 'none',
						padding: '20px 20px 12px 20px',
					}}
				>
					{modalTitle || title}
					<IconButton onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent
					sx={{
						padding: '20px',
					}}
				>
					{children}
				</DialogContent>
				{showActions && (
					<DialogActions sx={{ borderTop: '1px solid #E0E0E0', padding: '10px 20px' }}>
						<Button disabled={disableCancelButton} className="!text-dark" onClick={onClose}>
							{t('cancel')}
						</Button>
						<Button
							disabled={disableSaveButton || saveButtonLoading}
							loading={saveButtonLoading}
							onClick={save}
							color="primary"
							variant="contained"
						>
							{t(saveButtonTitle)}
						</Button>
					</DialogActions>
				)}
			</Dialog>
		</>
	);
};
